import { useState } from "react";

interface SubcategoryCircleProps {
  name: string;
  emoji: string;
  staticImage?: string;
  dbImage?: string;
  dbImageLoading?: boolean;
  gradientColor?: string;
  size?: "sm" | "md" | "lg";
  className?: string;
}

const sizeClasses = {
  sm: "w-7 h-7",
  md: "w-8 h-8",
  lg: "w-16 h-16 sm:w-20 sm:h-20",
};

export default function SubcategoryCircle({
  name,
  emoji,
  staticImage,
  dbImage,
  dbImageLoading = false,
  gradientColor = "from-primary/20 to-primary/40",
  size = "md",
  className = "",
}: SubcategoryCircleProps) {
  const [imgFailed, setImgFailed] = useState(false);

  const sizeClass = sizeClasses[size];
  const emojiSize = size === "lg" ? "text-2xl sm:text-3xl" : size === "md" ? "text-base" : "text-sm";

  // Priority: dbImage (from our server) → staticImage → emoji
  const imageSrc = (!imgFailed && dbImage) ? dbImage
    : (!imgFailed && staticImage && !staticImage.includes("placeholder")) ? staticImage
    : null;

  // Show shimmer while DB images are still loading and we have no image yet
  const showShimmer = !imageSrc && dbImageLoading;

  return (
    <div
      className={`${sizeClass} rounded-full overflow-hidden flex items-center justify-center shrink-0 ${
        imageSrc ? "bg-muted" : showShimmer ? "bg-muted animate-pulse" : `bg-gradient-to-br ${gradientColor}`
      } ${className}`}
    >
      {imageSrc ? (
        <img
          src={imageSrc}
          alt={name}
          className="w-full h-full object-cover"
          loading="eager"
          onError={() => setImgFailed(true)}
        />
      ) : showShimmer ? null : (
        <span className={`${emojiSize} drop-shadow-md`}>{emoji}</span>
      )}
    </div>
  );
}
